<template>
  <div class="medium-margin-top-m margin-bottom-m">
    <a
      data-type="cta"
      class="button emphasis expanded"
      :href="buildGWPUrl"
    >
      Shop Eligible Items
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePageData } from '@composables/usePageData';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';

const { productId = '' } = usePageData(); // TODO when is this empty
const { topLevelCategoryID } = useCommonProductGetters({ productId });
const buildGWPUrl = computed(() => `/shop/gifts-with-purchase/eligible-items?productId=${productId}&CategoryID=${topLevelCategoryID}&lid=gdp-shop_eligible_products`);

</script>
